import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m12 3.5c-4.6944 0-8.5 3.8056-8.5 8.5 0 4.6944 3.8056 8.5 8.5 8.5 4.6944 0 8.5-3.8056 8.5-8.5 0-2.2543-0.8955-4.4164-2.4896-6.0104s-3.7561-2.4896-6.0104-2.4896zm-10 8.5c0-5.5228 4.4772-10 10-10 2.6522 0 5.1957 1.0536 7.0711 2.9289 1.8753 1.8754 2.9289 4.4189 2.9289 7.0711 0 5.5228-4.4772 10-10 10-5.5228 0-10-4.4772-10-10z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.067 9.7333l-3.0667 3.0667-3.0667-3.0667-0.93333 0.93329 4 4 4-4-0.9333-0.93329z",
  clipRule: "evenodd",
  fillRule: "evenodd"
})), 'ChevronDownCircle');